import { createFileRoute } from '@tanstack/react-router'

import { PlatformSettingsScreen } from '@/features/platform-settings/platform-settings-screen'
import { platformSettingsSearchSchema } from '@/features/platform-settings/platform-settings-search'

/** The market rules, the operators and the operator's alerts; the tab is in the address. */
export const Route = createFileRoute('/_app/platform/settings')({
  validateSearch: platformSettingsSearchSchema,
  component: PlatformSettingsScreen,
})
